class MessagesList {

    constructor() {

      if (!this.setVars())
        return

      this.setEvents()
      this.setWidths()

    }

    setVars() {

      this.section = document.querySelector('.messagesList')

      if (!this.section)
        return

      this.form         = this.section.querySelector('.messagesList__form')
      this.container    = this.section.querySelector('.messagesList__carousel')
      this.inner        = this.section.querySelector('.messagesList__carouselInner')
      this.wrapper      = this.container.querySelector('.messagesList__items')
      this.items        = this.wrapper.querySelectorAll('.messagesList__item')
      this.navPrev      = this.section.querySelector('.messagesList__arrow--prev')
      this.navNext      = this.section.querySelector('.messagesList__arrow--next')
      this.slideCurrent = 0
      this.slideLimit   = (this.items.length - 1)

      return true

    }

    setEvents() {

      $("#confession-form-name, #confession-form-text").click(function() {
          $(this).css('background-color', '#f4f5f7');
      });

      $(".messagesList__icons").click(function() {
          $(this).css('background-color', '#ffffff');
      });

      var that = this;

      $(".messagesList__carouselInner").swipeDetector().on("swipeLeft.sd swipeRight.sd", function(event) {
        if (event.type === "swipeLeft") {
            that.nextSlide();
        } else if (event.type === "swipeRight") {
            that.prevSlide();
        }
      });

      this.navPrev.addEventListener('click', (e) => {

        e.preventDefault()
        this.prevSlide()

      })

      this.navNext.addEventListener('click', (e) => {

        e.preventDefault()
        this.nextSlide()

      })

      window.addEventListener('resize', (e) => {
        this.setWidths()
        this.setSlide()
      })

    }

    setWidths() {

      const count = this.items.length

      if (!count)
        return

      this.wrapper.style.width = ''
      this.items.each((item) => {
        item.style.width = ''
      })

      const width    = this.items[0].offsetWidth
      const maxWidth = this.container.offsetWidth

      this.container.style.width = maxWidth + 'px'
      this.wrapper.style.width = (width * count) + 'px'
      this.items.each((item) => {
        item.style.width = width + 'px'
      })

    }

    prevSlide() {

      this.slideCurrent--

      if (this.slideCurrent < 0)
        this.slideCurrent = this.slideLimit - 1

      this.setSlide()

    }

    nextSlide() {

      this.slideCurrent++

      if (this.slideCurrent >= this.slideLimit)
        this.slideCurrent = 0

      this.setSlide()

    }

    setSlide() {

      const width  = this.items[0].offsetWidth
      const offset = this.slideCurrent * -width

      this.inner.style.transform       = 'translateX(' + offset + 'px)'
      this.inner.style.webkitTransform = 'translateX(' + offset + 'px)'

    }

  }
